import type { TOC } from '@ember/component/template-only';

const ReportsRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default ReportsRouteTemplate;
